import { combineReducers } from "redux"

import LayoutReducer from "../slices/layouts/reducer"
import UserReducer from "../slices/user"

import { configureStore } from "@reduxjs/toolkit"

const rootReducer = combineReducers({
  Layout: LayoutReducer,
  User: UserReducer,
})

// RootState type
export type RootState = ReturnType<typeof rootReducer>

export const store = configureStore({ reducer: rootReducer, devTools: true })

// Type for dispatch function
export type AppDispatch = typeof store.dispatch
